import "./App.css";
import Header from "./Components/Header";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
// import Curriculum from "./Components/Curriculum";
// import AboutUs from "./Components/AboutUs";
import Contact from "./Components/Contact";
// import Exploremore from "./Components/Exploremore";
import Month1 from "./Components/Month1";
import Month2 from "./Components/Month2";
import Month3 from "./Components/Month3";
import Month4 from "./Components/Month4";
import Month5 from "./Components/Month5";
import Month6 from "./Components/Month6";
import Month7 from "./Components/Month7";
import AboutProgram from "./Components/AboutProgram";
import Timeline from "./Components/Timeline";
import Enquire from "./Components/Enquire";
import MonthTimeline from "./Components/MonthTimeline";
import ProgramsOverview from "./Components/ProgramsOverview";
import TechStack from "./Components/TechStack";
import AssessmentQuiz from "./Components/AssessmentQuiz";
import JobGuarantee from "./Components/JobGuarantee";
import BenefitsSection from "./Components/BenefitsSection";
// import Techstack from "./Components/Techstack";
// import Courses from "./Components/Courses";
// import PrivacyPolicy from "./Components/PrivacyPolicy";
// import RefundPolicy from "./Components/RefundPolicy";
// import TermsandConditions from "./Components/TermsandConditions";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/curriculum" element={<Curriculum />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/enquire" element={<Enquire />} />
          <Route path="/guaranteed-placement" element={<JobGuarantee />} />
          {/* <Route path="/aboutus" element={<AboutUs />} /> */}
          <Route path="/assessment" element={<AssessmentQuiz />} />
          {/* <Route path="/hybridlearning" element={<Exploremore />} /> */}
          <Route path="/month1" element={<Month1 />} />
          <Route path="/month2" element={<Month2 />} />
          <Route path="/month3" element={<Month3 />} />
          <Route path="/month4" element={<Month4 />} />
          <Route path="/month5" element={<Month5 />} />
          <Route path="/month6" element={<Month6 />} />
          <Route path="/job-guarantee" element={<Month7 />} />
          <Route path="/program" element={<AboutProgram />} />
          <Route path="/programdetails" element={<Timeline />} />
          <Route path="/6-month-program" element={<MonthTimeline />} />
          <Route path="/learning-path" element={<ProgramsOverview />} />
          <Route path="/tech_stack" element={<TechStack />} />
          <Route path="/benefits" element={<BenefitsSection/>} />
          
          {/* <Route path="/courses" element={<Courses />} /> */}
          {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
          {/* <Route path="/refund-policy" element={<RefundPolicy />} />  */}
          {/* <Route
            path="/terms-and-conditions"
            element={<TermsandConditions />}
          />  */}
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
